const projectStatuses = {
    ON_STANDBY: 'ON_STANDBY',
    ONGOING: 'ONGOING',
    ENDED: 'ENDED',
    ARCHIVED: 'ARCHIVED',
};

export default projectStatuses;
